/**
 * Bark package (docs/ux/project-tab-spec.md P1-bark / P1-discuss). Components for the Lanes tab
 * slots (`provideLanesSlots(BARK_SLOTS)` in routes/project-tab.tsx) and a self-contained
 * `BarkPanel` for other surfaces.
 */
import { createElement } from 'react'
import { BarkBox } from './BarkBox.js'
import { BarkInspector } from './BarkInspector.js'
import { OutcomeFeed } from './OutcomeFeed.js'

export { BarkBox, type BarkBoxProps } from './BarkBox.js'
export { BarkInspector, type BarkInspectorProps } from './BarkInspector.js'
export { BarkPanel } from './BarkPanel.js'
export { highlightTargets, OutcomeFeed, type OutcomeFeedProps } from './OutcomeFeed.js'
export { useBarkStore, useBarks } from './useBarks.js'

/** Structural match of the Lanes shell's `LanesSlots` (components/lanes/slots.tsx). */
export const BARK_SLOTS = {
  BarkBox,
  OutcomeFeed: (p: {
    projectId: string
    projectName: string
    limit: number
    onInspect: (key: string) => void
  }) => createElement(OutcomeFeed, p),
  /** `barkId` may carry a panel suffix (`<id>:redirect`) from the rail's Redirect. */
  BarkInspector: (p: { projectId: string; barkId: string; onInspect: (key: string) => void }) => {
    const [barkId = p.barkId, panel] = p.barkId.split(':')
    return createElement(BarkInspector, {
      projectId: p.projectId,
      barkId,
      onInspect: p.onInspect,
      ...(panel === 'redirect' ? { initialPanel: 'redirect' as const } : {}),
    })
  },
}
